import React, { useEffect } from 'react';
import { Category } from '@material-ui/icons';
import { CircularProgress, Link } from '@material-ui/core';

import { ApolloError, useLazyQuery, useMutation } from '@apollo/client';
import { Toast } from 'components/Toast';
import { getFriendlyErrorMessage } from 'utils/errorHelper';
import {
  CATEGORIZE_TITLES,
  TITLE_HAS_TRANSLATIONS,
} from 'queries/titleContent';
import Swal from 'sweetalert2';
import useStyles from '../FormContents/components/ActionButtons/styles';

interface ICategorizeTitlesProps {
  id: string;
  originalTitleId?: string;
  inView: boolean;
}

export const CategorizeTitles: React.FC<ICategorizeTitlesProps> = ({
  id,
  originalTitleId,
  inView,
}) => {
  const classes = useStyles();

  const [
    loadTitleHasTranslations,
    { data: titleHasTranslationsData, loading: titleHasTranslationsLoading },
  ] = useLazyQuery(TITLE_HAS_TRANSLATIONS, {
    variables: {
      id,
    },
  });

  useEffect(() => {
    let mounted = true;

    if (mounted && inView && !originalTitleId) {
      loadTitleHasTranslations();
    }

    return () => (mounted = false as any);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadTitleHasTranslations, inView]);

  const handleOnCompletedMutation = () => {
    Toast('Action executed with success!');
  };

  const handleOnErrorMutation = (error: ApolloError) => {
    Toast(getFriendlyErrorMessage(error), 'error');
  };

  const [categorizeTitles] = useMutation(CATEGORIZE_TITLES, {
    onCompleted: handleOnCompletedMutation,
    onError: handleOnErrorMutation,
  });

  const confirmAlert = async (subtitle: string) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      html: subtitle,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#78001b',
      reverseButtons: true,
      confirmButtonText: 'Confirm',
      customClass: {
        container: classes.swalDialog,
      },
    });
    return result.value;
  };

  const handleClick = async () => {
    if (
      await confirmAlert(
        'Do you want to recategorize all titles created from this?',
      )
    ) {
      categorizeTitles({
        variables: {
          originalTitleId: id,
        },
      });
    }
  };

  if (titleHasTranslationsLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <CircularProgress color="inherit" size={20} />
      </div>
    );
  }

  if (originalTitleId || !titleHasTranslationsData?.titleHasTranslations) {
    return <></>;
  }

  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      onClick={() => handleClick()}
      title="Recategorize all titles created from this"
    >
      <Category
        style={{
          marginRight: '8px',
          marginTop: '3px',
          width: '22px',
        }}
      />
    </Link>
  );
};
